module.exports = __webpack_public_path__ + "7b0dc607ed5787dd298d39c268b421bf.MP3";